import { exportToCSV, exportToPDF } from '../../../../utils/exportUtils';
import React, { useState, useRef } from 'react';
import AppCard from '../../../../components/ui/AppCard';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { useMountEffect } from 'primereact/hooks';
import apiClient from "../../../../services/api-client";
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
import StorageHelper from '../../../../utils/storage-helper';

        
        

export default function LoanHistory() {
    const [globalFilter, setGlobalFilter] = useState('');
  const dt = useRef(null);
    const toast = useRef(null);
  const [banksAvailable, setBanksList] = useState([]);
  const [loadingbanks, setLoadingBanks] = useState(false)

  async function fetchAllBanks() {
    
    let activeProducts = []
    await apiClient.get('policy/banks', {
      headers: {
        Authorization: 'Bearer ' + StorageHelper.get('token'),
        'Content-Type': 'application/json'
      }
    }).then((response) => {

        let products = response.data.responseBody

        products.forEach(product => {

            activeProducts.push(product)
        });

        
        
        //console.log(response.data.responseBody)
    });
    setBanksList(activeProducts);
  }

  useMountEffect(() => {
    fetchAllBanks()
});

  const cols = [
    { field: 'index', header: '#' }, 
    { field: 'BankID', header: 'BANK ID' },
    { field: 'BankName1', header: 'Bank Name' },

  ];


  const getBanksFromEasipol = async () =>{
    setLoadingBanks(true)
    await apiClient.get('policy/banks/easipol', {
      headers: {
        Authorization: 'Bearer ' + StorageHelper.get('token'),
        'Content-Type': 'application/json'
      }
    }).then((response) => {

        if(response.data.status === 'SUCCESS'){
          setLoadingBanks(false)
            toast.current.show({ severity: 'info', summary: 'Info', detail: 'You have pulled banks from easipol' });
            fetchAllBanks()
        }

    });
  }

  
  const globalFilterElement = (
    <div className="relative w-full max-w-xs">
        <i className="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-base-content/50"></i>
        <input
            type="text"
            className="input input-bordered w-full pl-10 h-10 shadow-sm bg-base-100 rounded-full"
            placeholder="Search..."
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
        />
    </div>
  );

  const header = (
      <div className="flex flex-col sm:flex-row gap-4 justify-between items-center w-full">
          {globalFilterElement}
          <div className="flex items-center gap-3 ml-auto">
              <button className="btn btn-primary rounded-full h-10 min-h-0 shadow-sm px-6" onClick={() => getBanksFromEasipol()}>
                  <i className="pi pi-sync"></i> Synchronise Easipol
              </button>
              <div className="dropdown dropdown-end">
                  <div tabIndex={0} role="button" className="btn btn-outline btn-ghost h-10 min-h-0 shadow-sm rounded-full">
                      <i className="pi pi-file-export"></i> Export
                  </div>
                  <ul tabIndex={0} className="dropdown-content z-[99] menu p-2 shadow-sm bg-base-100 border border-base-200 rounded-box w-52 mt-2">
                                    <li><button type="button" onClick={() => exportToCSV(dt, 'Banks')}><i className="pi pi-file-excel text-success"></i> Download CSV</button></li>
                                    <li><button type="button" onClick={() => exportToPDF(dt, 'Banks', 'Banks Report')}><i className="pi pi-file-pdf text-error"></i> Download PDF</button></li>
                                </ul>
              </div>
          </div>
      </div>
  );

  return (
    <div className="w-full">
      <AppCard title="Active Banks List">
    <Toast ref={toast} />
      
        {loadingbanks === false ? 
        <DataTable ref={dt}
          header={header}
          globalFilter={globalFilter}
          paginatorTemplate="CurrentPageReport RowsPerPageDropdown PrevPageLink PageLinks NextPageLink"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 25, 50]}
          value={banksAvailable.map((item, index) => ({ ...item, index: index + 1 }))}
          emptyMessage="No Banks found"
        >
          {cols.map((col, index) => {
            
            return <Column key={index} field={col.field} header={col.header} />;
          })}
        </DataTable>
        :
          <>
          <div className="w-full md:w-6 p-3">
                    <Skeleton className="mb-2"></Skeleton>
                    <Skeleton width="10rem" className="mb-2"></Skeleton>
                    <Skeleton width="5rem" className="mb-2"></Skeleton>
                    <Skeleton height="2rem" className="mb-2"></Skeleton>
                    <Skeleton width="10rem" height="4rem"></Skeleton>
                </div>
          </>
        }
      </AppCard>
    </div>
  );
}
